import axios from 'axios';
import {
  baseUrl,
} from '@/config';

export default {
  /**
   * [getConfigInfoDeviceList 구성정보 > dbms > 그룹 > 장비 목록 데이터 호출]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [description]
   * @return {[type]}        [description]
   */
  getDbmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-dbms-config-info-device-list.do`, params);
  },
  /**
   * [exportDbmsConfigInfoDeviceList 엑셀출력]- 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} params [managegroupId]
   * @return {[type]}        [description]
   */
  exportDbmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-dbms-config-info-device-list.do`, params);
  },
  /**
   * 노드> 요청 Parameter 정보
   * @author hyo
   * @param
   * @return
   */
  getDatabaseObjInfoParams(params) {
    return axios.post(`${baseUrl}/config/get-database-obj-info-params.do`, params);
  },

  /**
   * 노드>
   * @author hyo
   * @param
   * @return
   */
  getDatabaseTypeList(params) {
    return axios.get(`${baseUrl}/config/get-database-type-list.do`, {
      params,
    });
  },
  /**
   * 노드>구성현황 기본정보
   * @author hyo
   * @param
   * @return
   */
  getDbConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-db-config-info-basicstatus.do`, params);
  },
  /**
   * 노드 > 구성현황 수정
   * @author hyo
   * @param
   * @return
   */
  updateDbConfigInfo(params) {
    return axios.post(`${baseUrl}/config/update-db-obj-config.do`, params);
  },
  /**
   * [getDbmsChangeHistDate 성능/운영 > 구성관리 > dbms 변경이력 날짜 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDbmsChangeHistDate(params) {
    return axios.post(`${baseUrl}/config/get-dbms-change-hist-date.do`, params);
  },
  /**
   * [compareDbmsConfigHist 성능/운영 > 구성관리 > dbms 변경이력 날짜 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  compareDbmsConfigHist(params) {
    return axios.post(`${baseUrl}/config/compare-dbms-config-hist.do`, params);
  },
  getListenerFromOracleAccessInfo(params) {
    return axios.post(`${baseUrl}/config/get-listener-from-oracle-access-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/database/database-info.js